module.exports = __webpack_public_path__ + "media/images/cms/img_slide_19-fc5042c7e267e156f97a6ab89b508d91.jpg";